import React, { useEffect } from 'react';
import { useState } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonFooter, IonPage, IonTitle, IonToolbar, IonMenuToggle, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonButton, IonIcon, IonLabel } from '@ionic/react';
import { useIonViewWillEnter, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Loader } from 'citric_components';
import Menubar from '../Dashboard/Menubar';
import { App } from '@capacitor/app';

import { Avatar } from 'citric_components';

import CardImg from '../../images/card.png';
import { useNavigate } from 'react-router';

import conf from '../../config.json';
import { generateKey } from '../Util/Util';
import Phone from '../cati/Phone.js';

//import { Web } from '../../assets/sip.js';
//import { Web } from 'sip.js'
import { logD } from '../Util/Util';
import Header from '../Dashboard/Header';

export function isCATI(item) {
    if(item.idType == 6) {
        return true;
    } else {
        return false;
    }
}

export default function Releases(props) {
    logD("Releases", props);
    const launchs = props.project.launchsDash;
    const project = props.project;
    const projects = props.projects;

    const navigate = useNavigate();

    function back() {
        //props.setProject(null);
        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    useIonViewDidEnter(async () => {
        App.addListener('backButton', ({canGoBack}) => {
            
            if(!canGoBack){
                App.exitApp();
            } else {
                back();
            }
        });
    });

    // Helper function to get an HTML audio element
    function getAudioElement(id) {
        const el = document.getElementById(id);
        if (!(el instanceof HTMLAudioElement)) {
        throw new Error(`Element "${id}" not found or not an audio element.`);
        }
        return el;
    }

    function getVideoElement(id) {
        const el = document.getElementById(id);
        if (!(el instanceof HTMLVideoElement)) {
        throw new Error(`Element "${id}" not found or not an video element.`);
        }
        return el;
    }

    /* useEffect(() => {
        // Options for SimpleUser
        const options = {
            aor: "sip:citricdata@sip.linphone.org", // caller
            media: {
                constraints: { audio: true, video: false }, // audio only call
                remote: { audio: getAudioElement("remoteAudio") }, // play remote audio
                //remote: { video: getVideoElement("remoteVideo"), audio: getAudioElement("remoteAudio") },
                //local:  {
                //    video: getVideoElement('localVideo')
                //}
            },
            userAgentOptions: {
                authorizationUsername: "citricdata",
                authorizationPassword: "CitricPhone$22"
            }
        };
        
        // WebSocket server to connect with
        const server = "wss://citricdata.ddns.net/mfstwebsock";
        
        // Construct a SimpleUser instance
        const simpleUser = new Web.SimpleUser(server, options);
        
        // Connect to server and place call
        simpleUser.connect()
        .then(async () => {
             // Register to receive inbound calls
            //await simpleUser.register();
            simpleUser.call("sip:citricdev@sip.linphone.org")
        })
        .catch((error) => {
            console.error(error);
        });
    }, []); */

    return (
        <>
            { projects.length == 1 && <Menubar lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken} contentId="releases"/> }
            <IonPage id="releases">
                <IonHeader>
                    <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                    <IonToolbar className="toolbar-azul">
                        <IonButtons slot="start">
                            { /*projects.length == 1 &&
                                <IonMenuToggle className="ion-padding-start">
                                    <Avatar name={props.token.name.charAt(0).toUpperCase()}/>
                                </IonMenuToggle>*/
                            }
                            { projects.length > 1 &&
                                <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                            }
                        </IonButtons>
                        <IonTitle>{t('surveys')}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    {/*<Phone />*/}
                    {
                        /* <audio id="remoteAudio" controls>
                            <p>Your browser doesn't support HTML5 audio.</p>
                        </audio> */
                    }
                    {   /*<>
                        <video id="remoteVideo"></video>
                        <video id="localVideo" muted="muted"></video>
                        </>*/
                    }
                    {launchs == null && <Loader />}
                    {
                        launchs != null &&
                        <>
                        <IonGrid>
                            <IonRow>
                            {
                                launchs.map(function(item) {
                                    return <IonCol key={item.idLaunch} size="12" size-xl="4" size-lg="6">
                                            <IonCard className="releaseCard">
                                                <img src={CardImg} alt={t('bn_squared_logo')}/>
                                                <IonCardHeader>
                                                    <IonCardTitle>{item.release.name}</IonCardTitle>
                                                    <IonCardSubtitle>{item.release.desc}</IonCardSubtitle>
                                                    <IonCardSubtitle>{item.description}</IonCardSubtitle>
                                                </IonCardHeader>

                                                <IonCardContent>
                                                    <IonToolbar className='toolbar-buttons'>
                                                        {item.urls.length > 0 && !isCATI(item) && <IonButtons slot="start">
                                                            <IonButton color="primary" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    //props.setLaunch(launch);
                                                                    var keyNote = generateKey(item.idLaunch);
                                                                    props.setKeyNote(keyNote);
                                                                    props.setUrl(conf.Vprotocol + '://' + conf.Vhost + ':' + conf.Vport + '/' + conf.Vcontext + '/answer/a/' + item.urls[0].data + "?note=" + keyNote);
                                                                    props.setTitle(item.release.name + " - " + item.description);
                                                                    props.setTypeUrl('survey_start');
                                                                    setTimeout(function(){
                                                                        navigate('../webview/'+item.idLaunch);
                                                                    }, 100);
                                                                }
                                                            }>
                                                                {t('start_survey')}
                                                            </IonButton>
                                                        </IonButtons>
                                                        }
                                                        {item.urls.length > 0 && isCATI(item) && <IonButtons slot="start">
                                                            <IonButton color="primary" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    props.setLaunch(item);
                                                                    if(props.token.r != 4) {
                                                                        props.setInterviewer(item.urls[0].idUser);
                                                                    }
                                                                    setTimeout(function(){
                                                                        navigate("../cati/"+item.idLaunch);
                                                                    }, 100);
                                                                }
                                                            }>
                                                                {t('history')}
                                                            </IonButton>
                                                        </IonButtons>
                                                        }
                                                        {!isCATI(item) && <IonButtons slot="end">
                                                            <IonButton color="tertiary" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    props.setLaunch(item);
                                                                    if(props.token.r != 4) {
                                                                        props.setInterviewer(item.urls[0].idUser);
                                                                    }
                                                                    setTimeout(function(){
                                                                        navigate("../history/"+item.idLaunch);
                                                                    }, 100);
                                                                }
                                                            }>
                                                                {t('history')}

                                                            </IonButton>

                                                        </IonButtons>}
                                                        <IonButtons slot="end">
                                                            <IonButton color="secondary" onClick={(e) => {
                                                                    e.preventDefault();
                                                                    /*props.setLaunch(item);
                                                                    setTimeout(function(){
                                                                        navigate.push('/dashboard/survey');
                                                                    }, 1);*/
                                                                    //openURLInNewTab(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + props.project.idProject + '&sv=' + item.release.idDraft + '&pl=' + item.idLaunch + '&qa=1');
                                                                    props.setLaunch(item);
                                                                    props.setUrl(conf.BEprotocol + '://' + conf.Thost + ':' + conf.Tport + '/' + conf.Tcontext + '?project=' + props.project.idProject + '&sv=' + item.release.idDraft + '&pl=' + item.idLaunch + '&qa=1&nomb=1');
                                                                    props.setTitle(t('tracking'));
                                                                    props.setTypeUrl('tracking');
                                                                    setTimeout(function(){
                                                                        navigate('../webview/'+item.idLaunch);
                                                                    }, 100);
                                                                }
                                                            }>{t('tracking')}</IonButton>
                                                        </IonButtons>
                                                    </IonToolbar>
                                                </IonCardContent>
                                            </IonCard>
                                        </IonCol>
                                })
                            }
                            </IonRow>
                        </IonGrid>
                        </>
                    }
                </IonContent>
                <IonFooter>
                    <IonToolbar>
                        <IonTitle className="text-center">{t('logged_in_as')} <span className='color-orange'><b>{props.token.name}</b></span></IonTitle>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        </>
    );
}